import React from 'react'
import Table from 'UI/Table';

const JobsTable = ({ jobs }) => (
  <Table
    filterable
    data={jobs}
    pageSize={jobs.length}
    showPagination={false}
    columns={[
      { Header: 'Job ID', id: 'commvault_job_id', accessor: (object) => parseInt(object.commvault_job_id) },
      { Header: 'Data Written', accessor: 'data_written_in_bytes', Cell: row => row.original.data_written },
      { Header: 'Subclient', accessor: 'subclient_display_name' },
      { Header: 'Backup Level', accessor: 'backup_level_name' },
      { Header: 'Start Time', accessor: 'start_time' },
      { Header: 'End Time', accessor: 'end_time' },
      {
        Header: 'Retain Until',
        accessor: 'retain_until_at',
        Cell: row => <span style={(row.original.retention_passed) ? { color: 'red' } : {}}>{row.value}</span>
      }
    ]}
  />
)

export default JobsTable
